import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import pt_PT from 'antd/es/locale/pt_PT';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { AppContextProvider } from './context/AppContext';

import moment from 'moment';
import 'moment/locale/pt';

moment.locale('pt');

ReactDOM.render(
  <ConfigProvider locale={pt_PT}>
    <AppContextProvider>
      <App />
    </AppContextProvider>
    ,
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
